import apiClient from '@/services/axios'

export async function del(rewardId) {
  var response = await apiClient.delete('/rewards/' + rewardId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to delete Reward.')
}